import React from 'react';

import './Inputs.css';

export const LabelledInput = (props) => {

    let { inputValue, label, icon } = props ;

    // let InputElement = null;
    
    // switch(inputType){
    //     case('textarea'):
    //         InputElement = <textarea { ...props } />
    //         break;
    //     case('select'):
    //         InputElement = <select>
    //             props.options.map
    //         </select>
    //         break;
    //     default:
    //         InputElement = <input pr/>
    //         break;
    // }

    return (
        <React.Fragment>
            <label className="label-txt">{label}</label>
            <div className="form-group inputWithIcon">
                <input
                    className="user__form form-control"
                    readOnly="true"
                    value={inputValue}/>
                <i className={icon} aria-hidden="true"/>
            </div>
        </React.Fragment>
    );
}

export const FormInput = (props) => {

    const { inputValue, label, icon, form } = props ;
    let modifiedLabel = label.toLowerCase().replace(' ', '_');
    return (
        <React.Fragment>
            <label className="label-txt">{label}</label>
            <div className="form-group inputWithIcon">
                <input
                    type="text"
                    autoComplete="off"
                    className="user__form form-control"
                    data-form={form} 
                    placeholder={label}
                    name={modifiedLabel}
                    value={inputValue}
                    onChange={props.onChange}
                    {...props}
                    />
                <i className={icon} aria-hidden="true"/>
            </div>
            {/* Input error Message */}
            <div id={modifiedLabel} className="errorHandler text-left grid__full">
                <span id={`${modifiedLabel}-msg`} className="hidden error-element"></span>
            </div>
        </React.Fragment>
    );
}

export const SmallInput = (props) => {

    return (
        <input
            type="text"
            className="SmallInput"
            onFocus="yes" 
            value={props.value}
            onChange={props.onChange}/>
    );
}


export default function Input(props) {
    let InputElement = null;
    
    switch(props.inputType){
        case('textarea'):
            InputElement = <textarea { ...props } />
            break;
        case('select'):
            InputElement = <select>
                props.options.map
            </select>
            break;
        default:
            InputElement = <input pr/>
            break;
    }
    return (
    <div className="InputGroup">
      <label>{this.props.label}</label>
      {InputElement}
    </div>
  )
}
